import { selector } from '@/lib/selectors';

// Leaf selectors: nothing from domain/ is imported here at runtime, so any
// selector module can depend on this one without an import cycle.
const companies = (state) => state.companies;

export const configurationCompanySelector = selector(companies, (c) => c.configurationCompany);
export const companyCapabilitiesStateSelector = selector(companies, (c) => c.companyCapabilities);
export const companyFeaturesSelector = selector(companyCapabilitiesStateSelector, (f) => f.get('features'));
export const companyFeatureFlagsSelector = selector(companyFeaturesSelector, (f) => f.map((item) => item.get('value')));
export const companyApprovalsStampFeatureEnabledSelector = selector(companyFeatureFlagsSelector, (f) =>
  f.get('approval_stamp'),
);
